// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__BLxMk","item":"PaymentsMobile_item__24V6J","label":"PaymentsMobile_label__3bEXq","amount":"PaymentsMobile_amount__26uj8"};